/**
 * navigation
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_navigation.css';
import './_navigation.twig';

// Debounce functionality.
const { debounce } = require('lodash');

export const name = 'navigation';

export const defaults = {
  dummyClass: 'js-navigation-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { navigation = {} }) {
  // Find our component within the DOM
  const $navigation = $('.navigation', $context);
  // Bail if component does not exist
  if (!$navigation.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...navigation,
  };
  // An example of what could be done with this component
  $navigation.addClass(settings.dummyClass);

  // When clicking the parent navigation main items on mobile.
  $(document).on(
    'click',
    '.navigation__submenu-wrapper .navigation__item--parent > .navigation__link',
    (e) => {
      // On mobile triggers classes.
      const isParent = $(e.target).parent().is('.navigation__item--parent');
      if (isParent && window.innerWidth < 1024) {
        e.preventDefault();
        $(e.target).parent().toggleClass('navigation__item--active');
      }
    }
  );

  // When clicking the navigation back item on mobile.
  $(document).on('click', '.navigation__back', (e) => {
    // Looks for the active parent and removes the active class.
    $(e.target)
      .parents('.navigation__item--active')
      .eq(0)
      .removeClass('navigation__item--active');
  });

  // When resizing, if moving between breakpoints disables all mobile changes.
  $(window).on(
    'resize',
    debounce(() => {
      $('.navigation__item--active', $navigation).removeClass();
    }, 250)
  );
}

export default enable;
